var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-spinner',{attrs:{"small":_vm.small,"variant":"grey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }